module.exports = __webpack_public_path__ + "img/Data4Change-Logo-White.b971812f.svg";